import React from 'react'
import Header from '../Header/Header'
import Blog from './Blog'
import Footer from '../Footer/Footer'
import FeedbackForm from '../../FeedbackForm/FeedbackForm'

const BlogHome = () => {
    return (
        <div>
            <FeedbackForm />
            <Header />
            <Blog />
            <Footer />
        </div>
    )
}

export default BlogHome